import { useBaseListView } from '@/common/view/useBaseListView';
import { applicationService } from '@/services/applications';

export function useAppList() {
    const { list, total, fetchList } = useBaseListView({
        request: applicationService.app.list,
        hooks: {
            transformResponse: (list: any[]) =>
                list.map((item: any) => ({ ...item, status: item.removeTime ? 'Deleting' : '' }))
        }
    });

    return { list, total, fetchList };
}
